import { apiClient } from '@/shared/lib/api-client';
import type {
  Profile,
  ProfileAccessOverview,
  ProfileRecoveryLinkEmailBodyDto,
  ProfileRecoveryLinkEmailResult,
  ProfileStats,
  UpdateProfileDto,
} from '@bookclub/shared';

export async function fetchMe(): Promise<Profile> {
  return apiClient.get('me').json<Profile>();
}

export async function fetchProfileStats(): Promise<ProfileStats> {
  return apiClient.get('profile/stats').json<ProfileStats>();
}

export async function updateProfile(updates: UpdateProfileDto): Promise<Profile> {
  return apiClient.patch('me', { json: updates }).json<Profile>();
}

export async function fetchProfileAccessOverview(): Promise<ProfileAccessOverview> {
  return apiClient.get('profile/access').json<ProfileAccessOverview>();
}

export async function linkProfileRecoveryEmail(
  payload: ProfileRecoveryLinkEmailBodyDto,
): Promise<ProfileRecoveryLinkEmailResult> {
  return apiClient.post('profile/recovery/email-link', { json: payload }).json<ProfileRecoveryLinkEmailResult>();
}
